import { render } from "./FormCallback.vue?vue&type=template&id=40e4a8a9&scoped=true"
import script from "./FormCallback.vue?vue&type=script&lang=js"
export * from "./FormCallback.vue?vue&type=script&lang=js"

import "./FormCallback.vue?vue&type=style&index=0&id=40e4a8a9&scoped=true&lang=css"

import exportComponent from "C:\\Users\\admin\\Desktop\\Расчосков\\rascheskov_katarakta_lending\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40e4a8a9"]])

export default __exports__